/**
 * useHydration - Hydration tracking state & API calls
 * Extracted from App.js Phase 5 refactoring
 */
import { useState, useCallback } from 'react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const useHydration = () => {
  const [showHydrationModal, setShowHydrationModal] = useState(false);
  const [hydrationStatus, setHydrationStatus] = useState({
    hydration_ml: 0,
    hydration_goal_ml: 2500,
    hydration_liters: 0,
    hydration_goal_liters: 2.5,
    hydration_percent: 0,
    is_logged: false,
    goal_met: false
  });

  const loadHydrationStatus = useCallback(async (uid) => {
    try {
      const tzOffset = Math.round(-new Date().getTimezoneOffset() / 60);
      const response = await fetch(`${BACKEND_URL}/api/ai-miq/daily-checkin/${uid}/hydration-today?tz_offset=${tzOffset}`);
      if (response.ok) {
        const data = await response.json();
        setHydrationStatus({
          hydration_ml: data.hydration_ml || 0,
          hydration_goal_ml: data.hydration_goal_ml || 2500,
          hydration_liters: data.hydration_liters || 0,
          hydration_goal_liters: data.hydration_goal_liters || 2.5,
          hydration_percent: data.hydration_percent || 0,
          is_logged: data.is_logged || false,
          goal_met: data.goal_met || false
        });
      }
    } catch (error) {
      console.error('Error loading hydration status:', error);
    }
  }, []);

  const handleHydrationSuccess = useCallback((data) => {
    setHydrationStatus(prev => ({
      ...prev,
      hydration_ml: data.total_ml,
      hydration_goal_ml: data.goal_ml
    }));
  }, []);

  return {
    showHydrationModal,
    setShowHydrationModal,
    hydrationStatus,
    setHydrationStatus,
    loadHydrationStatus,
    handleHydrationSuccess
  };
};

export default useHydration;
